import { EVENT_TYPES } from "nemuru-components";
import { MILESTONES } from "../../../components/shared/sharedKernel/EventCatcher/config";
import { FLOW_MESSAGES } from "../../../components/shared/components/flowMessages/components";
import { modules } from "../../../components/modules";
import { SECTIONS } from "../../config";

export const flowVideoIdCaixaBank = {
  name: "Video ID",
  modules: [
    {
      id: modules.VIDEO_ID.id,
      section: {
        name: SECTIONS.IDENTIFICATION,
        progressPercentage: "50%",
      },
      onOK: {
        showOKMessage: {
          id: FLOW_MESSAGES.SECTION_IDENTIFICATION_END.id,
          fadeIn: true,
        },
        sendEvents: [
          {
            name: MILESTONES.KYC_COMPLETED,
            type: EVENT_TYPES.milestoneCompleted,
          },
        ],
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) => {
          return processState.videoIdProcessPassed === undefined;
        },
        welcomeMessageId: FLOW_MESSAGES.VIDEO_ID_WELCOME_MESSAGE.id,
      },
    },
    {
      id: modules.KYC_DOCUMENT_NUMBER_VALIDATION.id,
      section: {
        name: SECTIONS.IDENTIFICATION,
        progressPercentage: "100%",
      },
      onOK: {
        showOKMessage: {
          id: FLOW_MESSAGES.SECTION_IDENTIFICATION_END.id,
          fadeIn: true,
        },
        sendEvents: [
          {
            name: MILESTONES.KYC_COMPLETED,
            type: EVENT_TYPES.milestoneCompleted,
          },
        ],
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          processState.loan?.borrower_user_details_on_origination
            ?.familiar_situation_details &&
          !processState.loan?.borrower_bank_reader_id &&
          !processState.loan?.declared_income_id,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK_WITH_PROGRESS.id,
      },
    },
    {
      id: modules.VIDEO_ID_RESULT.id,
      onKO: null,
      section: {
        name: SECTIONS.IDENTIFICATION,
        progressPercentage: "100%",
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          processState.videoIdProcessPassed !== undefined,
      },
    },
  ],
};
